import { useCallback } from 'react';
import { usePublishDraftJobPost } from '~/domain/PermanentJobs';

interface IUsePublishJobPostPayload {
  jobPostingId?: string;
  planId?: string;
  promoCode?: string;
  expectedFinalPrice?: number;
  onSuccess?: () => void;
}

export const usePublishJobPost = ({
  jobPostingId,
  planId,
  promoCode,
  expectedFinalPrice,
  onSuccess,
}: IUsePublishJobPostPayload) => {
  const { error, isError, isPending, mutate } = usePublishDraftJobPost();

  const doPublish = useCallback(() => {
    if (!jobPostingId || !planId) {
      return;
    }

    mutate(
      { jobPostingId, planId, promoCode, expectedFinalPrice },
      {
        onSuccess,
      },
    );
  }, [jobPostingId, planId, promoCode, expectedFinalPrice, mutate, onSuccess]);

  return {
    isLoading: isPending,
    doPublish,
    isError,
    error,
  };
};
